module.exports = __webpack_public_path__ + "img/automoney-logo.8e9ea724.jpeg";